"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QiHuoSelectMiniChart = void 0;
var react_1 = __importStar(require("react"));
var title_1 = require("../title");
var mini_time_chart_1 = require("../mini_time_chart");
var qihuo_static_1 = require("../../../../modules/qihuo/qihuo_static");
require("./index.less");
/**
 * 期货select分时图
 * @returns
 */
function QiHuoSelectMiniChart(props) {
    var _a = (0, react_1.useState)(""), chartcode = _a[0], setChartCode = _a[1];
    (0, react_1.useEffect)(function () { }, []);
    return (react_1.default.createElement("div", { className: "titleminitc" },
        react_1.default.createElement(title_1.Title1, null,
            react_1.default.createElement(title_1.Title1.Main, null,
                props.link ?
                    react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(props.qihuomarket) }, props.children)
                    :
                        react_1.default.createElement(react_1.default.Fragment, null, props.children),
                react_1.default.createElement(SelectBox, __assign({}, props, { callback: setChartCode })))),
        react_1.default.createElement(mini_time_chart_1.MiniTimeChart, __assign({}, props, { quotecode: chartcode, key: chartcode, isqhquote: true }))));
}
exports.QiHuoSelectMiniChart = QiHuoSelectMiniChart;
/**
 * select下拉
 * @param props
 * @returns
 */
function SelectBox(props) {
    var _this = this;
    var _a = (0, react_1.useState)([]), level1 = _a[0], setLevel1 = _a[1];
    var _b = (0, react_1.useState)([]), level2 = _b[0], setLevel2 = _b[1];
    var _c = (0, react_1.useState)({}), defaultItem = _c[0], setDefaultItem = _c[1];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var level1, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, qihuo_static_1.getFutureSelectLevel1)(props.qihuomarket)
                        /** 115郑商所PTA特殊处理 */
                    ];
                    case 1:
                        level1 = _a.sent();
                        /** 115郑商所PTA特殊处理 */
                        if (level1.length > 0 && props.qihuomarket == '115') {
                            res = zssformat(level1);
                            setLevel1(res);
                            getLevel2(res[0].vtype);
                        }
                        if (level1.length > 0 && props.qihuomarket != '115') {
                            setLevel1(level1);
                            getLevel2(level1[0].vtype);
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    /** 获取二级列表 */
    var getLevel2 = function (vtype) { return __awaiter(_this, void 0, void 0, function () {
        var level2, default_item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, qihuo_static_1.getFutureSelectLevel2)(props.qihuomarket, vtype)];
                case 1:
                    level2 = _a.sent();
                    setLevel2(level2);
                    default_item = getDefaultItem(level2);
                    // console.log(default_item)
                    if (default_item === null || default_item === void 0 ? void 0 : default_item.code) {
                        setDefaultItem(default_item);
                        setChart(props.qihuomarket + '.' + default_item.code);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    /** 一级绑定 */
    var onchange1 = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var vtype;
        return __generator(this, function (_a) {
            vtype = e.target.value;
            getLevel2(vtype);
            return [2 /*return*/];
        });
    }); };
    /** 二级绑定 */
    var onchange2 = function (e) {
        var chart_code = props.qihuomarket + '.' + e.target.value;
        setChart(chart_code);
        var onselect = level2.filter(function (v) { return v.code == e.target.value; })[0];
        setDefaultItem(onselect);
    };
    /** 分时图 */
    var setChart = function (code) {
        props.callback && props.callback(code);
    };
    return (react_1.default.createElement("div", { className: "select_box" },
        level1.length > 0 && react_1.default.createElement("select", { className: "selects", onChange: onchange1 }, level1.map(function (v, i) {
            return react_1.default.createElement("option", { key: i, value: v.vtype }, v.vname);
        })),
        level2.length > 0 && react_1.default.createElement("select", { className: "selects", onChange: onchange2, value: defaultItem.code }, level2.map(function (v, i) {
            return react_1.default.createElement("option", { key: i, value: v.code }, v.name);
        }))));
}
/**
 * 获取二级默认选中选项
 * @param arr
 * @returns
 */
function getDefaultItem(arr) {
    if (arr.length < 1)
        return arr;
    var matchs = arr.filter(function (v) { return /主力|主连|次主力|次主连/i.test(v.name); });
    if (matchs.length > 0) {
        return matchs[0];
    }
    return arr[0];
}
/**
 * 郑商所PTA提前
 */
function zssformat(arr) {
    try {
        var pta_index = arr.findIndex(function (v) { return v.vname == 'PTA'; });
        if (pta_index != 0) {
            arr.unshift(arr.splice(pta_index, 1)[0]);
        }
        return arr;
    }
    catch (error) {
        return [];
    }
}
